// Sustituye a @aws-sdk/client-chime-sdk-messaging en el bundle web: el Chime SDK
// lo importa para DefaultMessagingSession, que esta app no usa. Debe ser ESM
// válido: el bundle se carga como <script type="module">, sin `module` global.
export {};
